<template>
  <div class="home">
    <landing-banner />
    <landing-course-preview />
    <landing-live
      :liveCourses="LiveCourses.todayLiveCourses"
      v-if="
        LiveCourses &&
          LiveCourses.todayLiveCourses &&
          LiveCourses.todayLiveCourses.length > 0
      "
    />
    <landing-teachers :teacherArray="teacherArray" />
    <Testimonials :reviews="CourseReviews" />
    <call-to-action />
  </div>
</template>

<script>
// @ is an alias to /src

import LandingLive from "../components/Landing/LandingLive";
import LandingBanner from "../components/Landing/LandingBanner";
import LandingCoursePreview from "../components/Landing/LandingCoursePreview";
import LandingTeachers from "../components/Landing/LandingTeacher";
import CallToAction from "../components/CallToAction/CallToAction";
import Testimonials from "../components/Testimonials/Testimonials";
import { teacherApi } from "../services/teacherApi";
import { store } from "../store/store";
import { videoApi } from "../services/videoApi";

export default {
  name: "home",
  data() {
    return {
      teacherArray: [],
      CourseReviews: [],
      LiveCourses: {}
    };
  },
  components: {
    LandingBanner,
    LandingCoursePreview,
    LandingLive,
    LandingTeachers,
    CallToAction,
    Testimonials
  },
  mounted() {
    this.getAllTeachers();
    this.getAllReview();
    this.getAllLive();
  },
  beforeRouteEnter(to, from, next) {
    if (store.state.user.loginStatus) {
      if (store.state.user.userRole === "student") {
        next({
          path: "/student/dashboard",
          query: {
            role: store.state.user.userRole
          }
        });
      } else if (store.state.user.userRole === "teacher") {
        next({
          path: "/admin/dashboard"
        });
      } else next();
    }
    next();
  },
  methods: {
    getAllTeachers() {
      teacherApi.getAllTeachers().then(res => {
        res.data.forEach(teacher => {
          teacher.isFollowing = false;
          this.teacherArray.push(teacher);
        });
        store.dispatch("teacher/setAllTeachers", this.teacherArray);
      });
    },
    getAllReview() {
      videoApi.getCourseReview().then(res => {
        this.CourseReviews = res.data;
      });
    },
    getAllLive() {
      videoApi.getAllLiveCourses().then(res => {
        this.LiveCourses = res.data.liveCourseResponse;
      });
    }
  }
};
</script>
